module.exports = __webpack_public_path__ + "img/Z85-X18-中_08.ce61e8e0.jpg";